<template>
	<div class="c-card-item" :class="{ 'c-card-item--border': border }" @click.stop="$emit('click', item)">
		<div class="c-card-item--title">{{ title }}</div>
		<div class="c-card-item--content">
			<slot name="content"></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: ''
		},
		item: {
			type: Object,
			default: () => {
				return {};
			}
		},
		border: {
			type: Boolean,
			default: true
		}
	}
};
</script>

<style lang="less" scoped>
@import '@/style/mixins';
.c-card-item {
	padding-bottom: 0.14rem;
	& + .c-card-item {
		margin-top: 0.14rem;
	}
	&--border {
		.thinner-border-bottom(#e8eaef);
	}
	&--title {
		font-family: 'PingFang SC';
		color: #333;
		font-size: 0.14rem;
		font-weight: 500;
		line-height: 140%;
	}
	&--content {
		margin-top: 0.085rem;
	}
}
</style>
